import {
    renderAccount,
    renderAircraft,
    renderCloudAhoy,
    renderBilling,
    renderCustomContent,
    renderDataDownloads,
    renderDirectory,
    renderDispatch,
    renderEnterpriseDocuments,
    renderDocs,
    renderFleetTracking,
    renderFlights,
    renderFSP,
    renderHoneywellForge,
    renderImagery,
    renderJetFuelX,
    renderLogbook,
    renderInsurance,
    renderMap,
    renderOrg,
    renderPeople,
    renderReservoir,
    renderRoster,
    renderTrackLogs,
    renderTripAssistant,
    renderOrgSettings,
    renderSmartGroups,
    renderRecap,
    renderDefaultRecap,
    renderChecklist,
    renderFlightScheduler,
    renderAirportDirectory,
    renderFleet,
} from 'ff/common/components/FFMenuV2/MenuItems';
import renderDivider from 'ff/common/components/FFMenuV2/MenuItems/Divider';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/FFMenu';
import fillSpace from 'ff/common/components/FFMenuV2/MenuItems/FillSpace';

export default function RenderDefaultMenu(params: RenderMenuParams) {
    return [
        renderDefaultRecap,
        renderDispatch,
        renderFleetTracking,
        renderFlights,
        renderMap,
        renderImagery,
        renderDocs,
        renderCustomContent,
        renderAircraft,
        renderFleet,
        renderFlightScheduler,
        renderAirportDirectory,
        renderLogbook,
        renderInsurance,
        renderTrackLogs,
        renderCloudAhoy,
        renderPeople,
        renderReservoir,
        renderDirectory,
        renderTripAssistant,
        renderHoneywellForge,
        renderRoster,
        renderDataDownloads,
        renderDivider,
        renderFSP,
        renderOrg,
        renderOrgSettings,
        renderSmartGroups,
        renderBilling,
        renderEnterpriseDocuments,
        renderJetFuelX,
        renderChecklist,
        renderDivider,
        renderAccount,
        fillSpace.bind(null, { flex: '1' }),
    ];
}
